import { apiClient } from '.';
import { DiscountCouponSearchQuery, CreateOrUpdateDiscountCouponBody } from '@models/discount-coupon';

export const searchDiscountCoupons = async (query: DiscountCouponSearchQuery) => {
  return apiClient.get('/admin/v1/discount-coupons', { params: query });
};

export const getDiscountCoupon = async (couponId: string) => {
  const response = await apiClient.get(`/admin/v1/discount-coupons/${couponId}`);
  return response.data;
};

export const createDiscountCoupon = async (body: CreateOrUpdateDiscountCouponBody) => {
  const response = await apiClient.post('/admin/v1/discount-coupons', body);
  return response.data;
};

export const updateDiscountCoupon = async ({
  couponId,
  body,
}: {
  couponId: string;
  body: CreateOrUpdateDiscountCouponBody;
}) => {
  const response = await apiClient.put(`/admin/v1/discount-coupons/${couponId}`, body);
  return response.data;
};

export const deleteDiscountCoupon = async (couponId: string) => {
  const response = await apiClient.delete(`/admin/v1/discount-coupons/${couponId}`);
  return response.data;
};

export const getDiscountCouponUsageStats = async (couponId: string) => {
  const response = await apiClient.get(`/admin/v1/discount-coupons/${couponId}/usage-stats`);
  return response.data;
};

export const getDiscountCouponsByCollectionId = async (collectionId: string) => {
  const response = await apiClient.get(`/admin/v1/discount-coupons/collections/${collectionId}`);
  return response.data;
};
